import React, { useEffect, useState } from 'react';
import { urlConstants } from '../../constants/urlConstants';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getUserClaims } from '../../utils/auth/unified-auth';
import { useAuth } from '../../utils/auth/useAuth';
import { FetchUserInfoAction } from '../../redux/action/LandingPageAction';
import { Row, Col } from 'antd';
import { Button, Icon, CardV2 } from 'pepsico-ds';
import { SkeletonList } from '../../components/Skeleton/ResinSkeleton';
import { getSpendAnalyticsCardVisibilityFromEnv } from './chatUtils';
import './AIAssistant.scss';
import knowledgeAgentImg from "../../resources/knowledge_agent_new.png";
import spendAgentImg from "../../resources/spend_agent.png";
import miAgentImg from "../../resources/MI_agent_new.png";
import AILogo from "../../assets/AI-Logo.svg";

const AGENTS = [
  {
    id: "knowledge",
    title: "Knowledge Management",
    description: "AI-powered assistant that helps users explore market information and identify relevant insights.",
    image: knowledgeAgentImg,
    bullets: [
      "Global PepsiCo Procurement Policy and Procurement Productivity Framework, and more to come",
    ],
    // bestFor: "Vestibulum ante ipsum primis in faucibus",
  },
  {
    id: "market",
    title: "Market Intelligence",
    description: "AI-powered assistant that helps users explore market information and identify relevant insights.",
    image: miAgentImg,
    bullets: [
      "Fastmarket RISI (price, forecast, and news) - more market sources will be added soon",
    ],
    // bestFor: "Mauris faucibus, lorem sit amet consequat eleifend.",
  },
  {
    id: "spend",
    title: "Spend Analytics",
    description: "AI-powered assistant that provides answers and insights to understand and support spending decisions.",
    image: spendAgentImg,
    bullets: [
      "Spend analytics",
    ],
    // bestFor: "Track spend across suppliers, sectors and markets.",
  },
];

const { genAITermsUrl, privacyNoticeUrl } = urlConstants;

const AIAssistant = () => {
  const { authState } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userInfo, setUserInfo] = useState({});
  const [isUserDataFetched, setIsUserDataFetched] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const userData = useSelector(state => state.getUserInfoReducer);
  const isUserDataLoading = userData?.loading ?? true;
  const userAccessData = useSelector((state) => state.getUserAccessReducer);
  const isAIUser = userAccessData?.isAiUser;
  const showSpendAnalyticsCard = React.useMemo(
    () => getSpendAnalyticsCardVisibilityFromEnv(),
    [],
  );
  const visibleAgents = AGENTS;

  const handleAccessClick = (agentId) => {
    if (agentId === "market") {
      navigate("/ai-assistant/market-intelligence");
    } else if (agentId === "knowledge") {
      navigate("/ai-assistant/knowledge-management");
    } else if (agentId === "spend") {
      navigate("/spend-analytics-ai-agent");
    } else {
      console.log(`Access clicked for agent: ${agentId}`);
    }
  };

  /* istanbul ignore next */
  useEffect(() => {
    async function fetchUserInfo() {
      const user = await getUserClaims();
      if (user) {
        setUserInfo(user);
        dispatch(FetchUserInfoAction(user));
        setIsUserDataFetched(true)
      }
    }
    setIsDataLoading(true)
    fetchUserInfo();
  }, [])

  /* istanbul ignore next */
  useEffect(() => {
      return () => {
          dispatch({ 
              type: 'RESET_USER_INFO_ACTION', 
              payload: "RESET_USER_INFO_ACTION" 
          });
      };
  }, []);

  if (authState?.isAuthenticated) {
  return (
    <div className="ai-assistant-page">
      <div className="ai-assistant-inner">
        <div className="ai-header">
          <div className="ai-header-icon">
            {/* <Icon icon="auto_awesome" /> */}
            <img src={AILogo} alt="AI Logo" />
          </div>
          <h1 className="ai-header-title">Procurement Hub AI Assistants</h1>
          <p className="ai-header-subtitle">
            Choose your AI agent based on what you'd like to accomplish
          </p>
        </div>

        {/* <div className="ai-cards">
          {AGENTS.map((agent) => (
            <div className="ai-card" key={agent.id}>
              <div className="ai-card-image">
                <img src={agent.image} alt={agent.title} />
              </div>
              <div className="ai-card-body">
                <h3 className="ai-card-title">{agent.title}</h3>
                <p className="ai-card-description">{agent.description}</p>
                <ul className="ai-card-bullets">
                  {agent.bullets.map((bullet, i) => (
                    <li key={i}>{bullet}</li>
                  ))}
                </ul>
                <div className="ai-card-bestfor">
                  <span className="ai-card-bestfor-label">BEST FOR:</span>
                  <p className="ai-card-bestfor-text">{agent.bestFor}</p>
                </div>
                <div className="ai-card-action">
                  <Button
                    text="Access"
                    variant="primary"
                    size="medium"
                    iconTrailing="arrow_forward"
                    onClick={() => handleAccessClick(agent.id)}
                  />
                </div>
              </div>
            </div>
          ))}
        </div> */}

        <div className="ai-cards">
          <Row gutter={[16, 16]} justify={"center"} style={{ width: "100%", position: 'relative' }}>
          {visibleAgents.map((agent) => (
              <Col xs={24} sm={12} md={12} lg={8} xl={8} key={agent.id}>
                    <CardV2
                      className="ph-course-card"
                      cardBody={{
                        isDark: false,
                        slot: 
                        isUserDataLoading ? (
                          <div style={{ padding: '16px', width: '100%' }}>
                            <SkeletonList count={9} height="30" />
                          </div>
                        ) : 
                        <div
                                style={{
                                  // minHeight: "550px",
                                  width: "100%",
                                  height: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  fontFamily: 'Inter',
                                  borderRadius: "8px"
                                }}
                              >
              
                                <div className="ai-card" key={agent.id}>
                                  <div className="ai-card-image">
                                    <img src={agent.image} alt={agent.title} />
                                  </div>
                                  <div className="ai-card-body">
                                    <h3 className="ai-card-title">{agent.title}</h3>
                                    <p className="ai-card-description">{agent.description}</p>
                                    <ul className="ai-card-bullets">
                                      {agent.bullets.map((bullet, i) => (
                                        <li key={i}> <span style={{fontWeight: 700}}>Sources Covered: </span>{bullet}</li>
                                      ))}
                                    </ul>
                                    {/*<div className="ai-card-bestfor">
                                      <span className="ai-card-bestfor-label">BEST FOR:</span>
                                      <p className="ai-card-bestfor-text">{agent.bestFor}</p>
                                    </div> */}
                                  </div>
                                  
                                  {/* <div className="ai-card-action">
                                    
                                    <div style={{ background: 'var(--color-border-divider)', width: '100%', height: '1px', margin: '16px 0' }} className="divider"></div>
                                    <Button
                                      text="Access"
                                      variant="primary"
                                      size="Large"
                                      iconTrailing="arrow_forward"
                                      onClick={() => handleAccessClick(agent.id)}
                                    />
                                  </div> */}

                                  <div
                                    style={{
                                      display: 'flex',
                                      // alignItems: 'flex-end',
                                      justifyContent: 'center',
                                      // marginTop: '16px',
                                      // padding: "0px 24px 24px 0px"
                                      paddingTop: "0px",
                                      paddingBottom: "16px",
                                      paddingLeft: "16px",
                                      paddingRight: "16px",
                                      // border: "1px solid red"
                                    }}
                                    className="app-card-footer"
                                  >
                                    <div style={{ width:"100%" }}>

                                      <div style={{ background: 'var(--color-border-divider)', width: '100%', height: '1px', margin: '16px 0' }} className="divider"></div>
                                      <Button
                                        style={{ width:"100%" }}
                                        text={
                                          // agent.id === "spend" && !showSpendAnalyticsCard ? "Coming Soon" :

                                          // UNCOMMENT & COMMENT BELOW TO PART WHEN MI TO BE ENABLED
                                          agent.id === "market" && !isAIUser ? "Access: Level 8 and Above" :
                                          // agent.id === "market" ? "Coming Soon" : 
                                          "Access"
                                        }
                                        variant="primary"
                                        size="Large"
                                        iconTrailing={
                                          (agent.id === "spend" && !showSpendAnalyticsCard) ||

                                          // UNCOMMENT & COMMENT BELOW TO PART WHEN MI TO BE ENABLED
                                          // (agent.id === "market") ? undefined : "arrow_forward"
                                          (agent.id === "market" && !isAIUser) ? undefined : "arrow_forward"
                                        }
                                        disabled={
                                          (agent.id === "spend" && !showSpendAnalyticsCard) ||
                                          
                                          // UNCOMMENT & COMMENT BELOW TO PART WHEN MI TO BE ENABLED
                                          // (agent.id === "market")
                                          (agent.id === "market" && !isAIUser)
                                        }
                                        onClick={() => handleAccessClick(agent.id)}
                                      />
                                    </div>  
                                  </div>
                                </div>
                              </div>,
                        
                        type: 'slot',
                        
                      }}
                      maxScrollHeight="90px"
                      state="interactive"
                      style={{}}
                      type="basic"
                      viewport="desktop"
                    />
                    
              </Col>
          ))}
          </Row>
        </div>


        <p className="ai-input-disclaimer">
          By messaging the AI assistant, you confirm that you have read and agree to our{' '}
          <a href={genAITermsUrl} target="_blank" rel="noopener noreferrer">Terms & Conditions</a> and <a href={privacyNoticeUrl} target="_blank" rel="noopener noreferrer">Privacy Notice</a>.
          Please do not share sensitive information. Chats may be reviewed and used to improve our models. AI can make mistakes, so please verify important information.
        </p>
        {/* <p className="ai-help-text">
          Not sure which to choose? Start with the Knowledge Management Agent to
          get familiar with key procurement frameworks and global policies.
        </p> */}

        {/* <p className="ai-release-note">
          <a href="#release" className="ai-release-link">
            RISI Pricing Assistant
          </a>
          <span className="ai-release-sep"> — </span>
          <a href="#release" className="ai-release-link">
            [Release Notes]
          </a>
          <span className="ai-release-desc">
            : Added OCC 11 forecast output, insight generation, table and chart
            preview, and follow-up query suggestions.
          </span>
        </p> */}
      </div>
    </div>
  );
  }
};

export default AIAssistant;
